/**
 * 这是一个只读字段,用来用表单的样式显示一些只读信息, 而不受表单的控制
 */
import React from 'react';
import {FormField, FormFieldProps} from '../FormField';
import classNames from 'classnames';
import styles from './index.module.scss';

interface TextFieldProps
    extends Omit<
        FormFieldProps,
        'children' | 'name' | 'preserve' | 'disabled'
    > {
    children: React.ReactNode;
    noError?: boolean;
}

export default function TextField({
    children,
    noError,
    className,
    ...props
}: TextFieldProps) {
    return (
        <FormField
            {...props}
            className={classNames(className, {[styles.noError]: noError})}>
            <div>{children}</div>
        </FormField>
    );
}
